import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_357aiy2qup: FaireBrandEntity = {
  token: "b_357aiy2qup",
  type: "brand",
  name: "7th Ray",
  avatarUrl:
    "https://cdn.faire.com/fastly/d0f512b0fe398e658de4e67242a175a4444474df27c8f5846e4f4fc525bd95ba.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a1259737ff7a11a7f7f0d2ed1d1de39c253e9196a349023150e4f9127c5ec92d.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d0f512b0fe398e658de4e67242a175a4444474df27c8f5846e4f4fc525bd95ba.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a1259737ff7a11a7f7f0d2ed1d1de39c253e9196a349023150e4f9127c5ec92d.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.7,
  reviewCount: 515,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a clothing company based on Southern California - designed and manufactured in Los Angeles.\n\n7th Ray is our junior and young contemporary line.\n\nAs wholesalers who have been in this business for over ten years, we have developed the experience and understandings about the dynamics of the fashion industry. \n\nWe value and are always looking forward to build a strong relationship with our customers. \n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:11.666Z",
    importedBy: "entity-db-cli",
  },
};
